export default __webpack_public_path__ + "static/media/arrow-right-purple.4aedf4c0.svg";